import { Player } from '../../api';

export type PlayerForm = {
  id: string;
  name: string;
  camera: string;
  active: boolean;
  type: string;
  settings: any;
  allowedDomains: Array<string>;
};

export const initialState: PlayerForm = {
  id: '',
  name: '',
  camera: '',
  active: true,
  type: '',
  settings: {},
  allowedDomains: [],
};

export function toForm(player: any): any {
  return {
    ...player,
    settings: player.settings,
    allowedDomains: [...player.allowedDomains] || [],
    camera: player.camera.id,
  };
}

export function toPlayer(form: PlayerForm): Player {
  return { ...form, settings: form.settings };
}
